import React, { useState, useEffect } from "react";
import API from "../Services/Employee";
import APIS from '../Services/Auth'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DesignationList from "../Components/Designation";
import LocationList from "../Components/Location";
import moment from "moment";
import CenterModal from "../Components/CenterModal";
import APISS from '../Services/Location';
const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [id, setId] = useState([])
  const [empID, setEmpID] = useState("");
  const [designationId, setDesignationId] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [locationId, setLocationId] = useState([""]);
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const limit = 10;
  const [search, setSearch] = useState("")
  const [selectedLocation, setSelectedLocation] = useState("");

  const [locationName, setLocationName] = useState("");
  const [status, setStatus] = useState("");
  const [createdAt, setCreatedAt] = useState("");

  const [centerName, setCenterName] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState([]);
  const [location, setLocation] = useState([])


  useEffect(() => {
    const companyId = localStorage.getItem("company_id");
    if (companyId) {
      fetchEmployees();
      bindLocation();
    } else {
      setError("Company ID not found in localStorage.");
    }
  }, [currentPage]);

  const handleSelectedCenter = (selectedData) => {
    setSelectedCenter(selectedData);
  };

  const fetchEmployees = async () => {
    try {
      const response = await API.bindEmployeeList({
        company_id: 1,
        pageNumber: currentPage,
        limit: limit,
        search: search,
        location_id: parseInt(selectedLocation) || null,
        designation_id: null
      });

      if (response.status === 200) {
        //console.log('response?.data?.data', response?.data?.data)
        const totalRecords = response.data.totalCount;
        setEmployees(response?.data?.data || []);
        setTotalRecords(totalRecords);
        setError(null);
      } else {
        setError("No records found.");
        setEmployees([]);
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 403) {
          window.location.replace("/Login")
        } else if (status === 500) {
          console.error("Error 500: Internal Server Error - Something went wrong on the server.");
          toast.error("Internal server error. Please try again later.");
        }
      }
      setError("Error fetching employees: " + error.message);
      setEmployees([]);
    }
  };

  const totalPages = Math.ceil(totalRecords / limit);
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getPageNumbers = () => {
    const maxVisible = 10;
    const pageNumbers = [];
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const left = Math.max(1, currentPage - 3);
      const right = Math.min(totalPages, currentPage + 3);
      if (left > 2) {
        pageNumbers.push(1, '...');
      } else {
        for (let i = 1; i < left; i++) {
          pageNumbers.push(i);
        }
      }
      for (let i = left; i <= right; i++) {
        pageNumbers.push(i);
      }
      if (right < totalPages - 1) {
        pageNumbers.push('...', totalPages);
      } else {
        for (let i = right + 1; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      }
    }
    return pageNumbers;
  };
  const handleStatusToggle = async (id, currentStatus) => {
    const updatedStatus = !currentStatus;
    try {
      const response = await API.updateStatus(id);
      if (response.status === 200) {
        setEmployees((prevLocation) =>
          prevLocation.map((item) =>
            item.id === id ? { ...item, status: updatedStatus } : item
          )
        );
        toast.success(response.data.message);
        fetchEmployees();
      } else {
        console.log("Error updating status:", response);
        toast.error("Failed to update the status. Please try again.");
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 403) {
          window.location.replace("/Login")
        } else if (status === 500) {
          toast.error("Internal server error. Please try again later.");
        }
      }
    }
  };

  const handleGetData = async (id) => {
    try {
      setId(id);
      const response = await API.bindEmployeeList({ id: id });
      const fetchedData = response?.data?.data?.[0];
      // console.log('fetchedData', fetchedData);
      if (fetchedData) {
        setEmail(fetchedData?.email);
        setPhoneNo(fetchedData?.phone_no)
        setEmpID(fetchedData?.employee_code);
        setFirstName(fetchedData?.first_name)
        setLastName(fetchedData?.last_name)
        setAddress(fetchedData?.address)
        setDesignationId(fetchedData?.designation_id);
        // setLocationId(fetchedData?.location_id);
        setPincode(fetchedData?.pincode);
        setCity(fetchedData?.city_name);
        setState(fetchedData?.state_name);
        setDesignationName(fetchedData?.designation);
        setLocationName(fetchedData?.locations);
        setStatus(fetchedData?.status);
        setCreatedAt(fetchedData?.createdAt);
        // setLocationId(fetchedData?.location_id)
        const parsedLocations = JSON.parse(fetchedData?.locations || '[]');
        const locationIds = parsedLocations.map((location) => location.location_id);
        const location_name = parsedLocations.map((location) => location.location_name);
        //console.log('All location_ids:', locationIds);
        setLocationId(locationIds)
        setCenterName(location_name.join(', '))
      } else {
        toast.error("Failed to fetch receipt details.");
      }
    } catch (error) {

      if (error.response) {
        const status = error.response.status;
        if (status === 403) {
          window.location.replace("/Login")
        } else if (status === 500) {

          toast.error("Internal server error. Please try again later.");
        }
      }
      // console.error("Error fetching data:", error);
    }
  };
  const handleUpdate = async () => {
    if (!designationId) {
      toast.error("Please Select Designation.");
      return;
    }
    if (!firstName) {
      toast.error("Please Enter First Name.");
      return;
    }
    if (!phoneNo) {
      toast.error("Please Enter Mobile Number.");
      return;
    }
    if (!email) {
      toast.error("Please Enter Email Id.");
      return;
    }
    if (!address) {
      toast.error("Please Enter Address.");
      return;
    }
    if (!pincode) {
      toast.error("Please Enter 6 digit Pincode.");
      return;
    }

    if (
      (!selectedCenter || selectedCenter.length === 0) &&
      (!locationId || locationId.length === 0)
    ) {
      toast.error("Please select at least one center.");
      return;
    }
    const centerlist = Array.isArray(selectedCenter)
      ? selectedCenter.join(",")
      : selectedCenter;

    const payload = {
      // employee_id: empID,
      designation_id: designationId,
      first_name: firstName,
      last_name: lastName,
      phone_no: phoneNo,
      email: email,
      address: address,
      location_id: centerlist || (Array.isArray(locationId) ? locationId.join(",") : `${locationId}`),
      //  location_id: centerlist || locationId,
      pincode: pincode,
    };
    //console.log('paap', payload);
    try {
      const response = await API.updateEmployee(id, payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        fetchEmployees();
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(error.response.data.message || "Bad Request: Please check your input.");
        } else if (error.response.status === 403) {
          window.location.replace("/Login");
        } else {
          toast.error(`Error ${error.response.status}: ${error.response.data.message}`);
        }
      } else if (error.request) {
        toast.error("No response from server. Please try again later.");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    }
  };

  const getCityData = async (pincode) => {
    try {
      const response = await APIS.getCity(pincode);
      const postData = response?.data?.data;
      if (postData) {
        setCity(postData?.city_name || "");
        setState(postData?.state_name || "");
      } else {
        toast.warning('No city or state data found in the response');
       // console.log("No city or state data found in the response.");
      }
    } catch (error) {
      if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      console.error("Error fetching city data:", error.message || error);
    }
  };

  const handleSearch = () => {

    setCurrentPage(1);
    fetchEmployees();

  };

  function splitSmartText(text) {
    const result = [];
    let start = 0;

    while (start < text.length) {

      let end = Math.min(start + 55, text.length);
      let splitPoint = -1;

      for (let i = end; i >= start + 45; i--) {
        if (text[i] === ' ') {
          splitPoint = i;
          break;
        }
      }
      if (splitPoint === -1) splitPoint = end;

      result.push(text.slice(start, splitPoint).trim());
      start = splitPoint + 1;
    }

    return result;
  }

  const bindLocation = async () => {
    try {
      const response = await APISS.getLocationList({
        is_active: 1,
        limit: 0,
      });
      setLocation(response?.data?.data || []);
      // setLocation1(response?.data?.data || [])
    } catch (error) {
      //setError("Failed to fetch locations.");
      console.error(error);
      if (error.response.status == 403) {
        window.location.replace("/Login");
      }
    }
  };

  const handleResetPassword = async () => {
    try {

      const response = await API.resetPassword(id);
      if (response.status === 200) {
        toast.success(response.data.message);
      } else {
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.error("Reset password error:", error);
      const msg = error?.response?.data?.message || "Something went wrong";
      toast.error(msg);
    }
  };


  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Total Employees</h4>
          </div>
          <div className="card-body">
            {/* {error && <div className="alert alert-danger">{error}</div>} */}
            <div className="row mb-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="ddSalesType" className="form-label">
                    <b>Search by Employee Name</b>
                  </label>
                  <input type="text" className="form-control" placeholder="Search by Employee Name"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}

                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="ddSalesType" className="form-label">
                    <b>Center</b>
                  </label>
                  <select
                    className="form-select"
                    id="ddSalesType"
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                  >
                    <option value="">Select</option>
                    {location.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <label></label>
                <button onClick={handleSearch} className="btn btn-success" type="button">Search</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Action</th>
                    <th>Emp ID</th>
                    <th>Employee Name</th>
                    <th>Designation</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    <th>Center</th>
                    <th>Status</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.length > 0 ? (
                    employees.map((employee, index) => (
                      <tr
                        key={employee.id}
                        data-active={employee?.is_active ? "true" : "false"}
                      >
                        <td>{employee.SrNo}</td>
                        <td>
                          <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                            <ul className="navbar-nav navbar-nav-right">
                              <li className="nav-item nav-profile1">
                                <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                  <div className="nav-profile-text1">
                                    <p className="mb-1 text-black">
                                    </p>
                                  </div>
                                </span>
                                <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                  <a className="dropdown-item">
                                    <button onClick={() => handleGetData(employee?.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewEmp">
                                      View
                                    </button>
                                  </a>
                                  <div className="dropdown-divider"></div>
                                  <a className="dropdown-item">
                                    <button onClick={() => handleGetData(employee?.id)}
                                      className="btn btn-primary btn-sm" type="button"
                                      data-bs-toggle="modal" data-bs-target="#myModal"
                                    >
                                      Edit
                                    </button>
                                  </a>
                                  <div className="dropdown-divider"></div>
                                  <a className="dropdown-item">

                                    <button
                                      className={`btn btn-sm ${employee?.is_active ? "btn-secondary" : "btn-info"}`}
                                      onClick={() => handleStatusToggle(employee?.id, employee?.is_active)}
                                    >
                                      {employee?.is_active ? "De-Activate" : "Activate"}
                                    </button>

                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>{employee?.employee_code}</td>
                        <td>{employee?.full_name}</td>
                        <td>{employee?.designation}</td>
                        <td>{employee?.phone_no}</td>
                        <td>{employee?.email}</td>

                        <td>
                          {Array.isArray(employee?.locations)
                            ? employee.locations.map(loc => loc.location_name).join(", ")
                            : JSON.parse(employee?.locations || '[]').map(loc => loc.location_name).join(", ")
                          }
                        </td>

                        <td>{employee?.is_active ? "Active" : "De-Activated"}</td>
                        <td>{moment(employee?.createdAt).format("DD-MM-YYYY")}</td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No employees found.</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center mt-4">

                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>
                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                    >
                      {page === "..." ? (
                        <span className="page-link">...</span>
                      ) : (
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      )}
                    </li>
                  ))}

                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div className="modal fade" id="myModal" data-bs-backdrop="static">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">

              <div className="modal-header">
                <h4 className="modal-title">Update Employee</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">

                <div className="forms-sample">
                  <div className="row">

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="name">First Name <span style={{ color: "red" }}>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          id="txtfname"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                        //onChange={(e) => handleFieldChange(e, "firstName")}
                        />

                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="name">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="txtlname"
                          placeholder="Last Name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                        // onChange={(e) => handleFieldChange(e, "lastName")}
                        />

                      </div>
                    </div>
                    <div className="col-md-4">
                      <DesignationList
                        selectedDesignation={designationId}
                        setSelectedDesignation={setDesignationId}
                        designation={designationId}
                      />

                    </div>
                  </div>
                  <div className="row">


                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="email">Mobile <span style={{ color: "red" }}>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          id="txtmobile"
                          placeholder="mobile"
                          value={phoneNo}
                          maxLength={10}
                          onChange={(e) => setPhoneNo(e.target.value)}
                        // onChange={(e) => handleFieldChange(e, "phoneNo")}
                        />

                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="email">Email <span style={{ color: "red" }}>*</span></label>
                        <input
                          type="email"
                          className="form-control"
                          id="txtemail"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        // onChange={(e) => handleFieldChange(e, "email")}
                        />

                      </div>
                    </div>

                    <div className="col-md-4">
                      <CenterModal
                        onSelectCenter={handleSelectedCenter}
                        type="edit"
                        locationId={locationId}

                      />
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="address">Address <span style={{ color: "red" }}>*</span></label>
                        <textarea className="form-control" rows={1} id="txtaddress"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="city">PinCode <span style={{ color: "red" }}>*</span></label>
                        <input
                          type="text"
                          maxLength={6}
                          className="form-control"
                          id="txtpincode"
                          placeholder="Pin Code"
                          value={pincode}
                          onChange={(e) => {
                            const value = e.target.value;
                            setPincode(value);
                            if (value.length < 6) {
                              setCity("");
                              setState("");
                              return;
                            }
                            if (value.length === 6) {
                              getCityData(value);
                            }
                          }}
                        />

                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="city">City</label>
                        <input
                          type="text"
                          className="form-control"
                          id="txtcity"
                          placeholder="City"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="city">State</label>
                        <input
                          type="text"
                          className="form-control"
                          id="txtstate"
                          placeholder="State"
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <button className="btn btn-primary me-4" onClick={handleUpdate}>Update</button>
                  <button className="btn me-4"
                    style={{ backgroundColor: "#c01515ff", color: "#fff" }}
                    onClick={handleResetPassword}>Reset Password <span className="mdi mdi-lock-reset"></span></button>
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="modal" id="myModalViewEmp">
          <div className="modal-dialog  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Employee Details</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="table-responsive">
                  <table className="table table-bordered border-secondary">
                    <thead>
                      <tr>
                        <th>EmpID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Designation</th>
                        <th>Mobile</th>
                      </tr>
                      <tr>
                        <td>
                          {empID}
                        </td>
                        <td>
                          {firstName}
                        </td>
                        <td>
                          {lastName}
                        </td>
                        <td>{designationName}</td>
                        <td>{phoneNo}</td>
                      </tr>
                      <tr>


                        <th>Email</th>
                        <th colSpan={2}>Address</th>
                        <th colSpan={2}>Center name</th>
                      </tr>
                      <tr>

                        <td>{email}</td>
                        <td colSpan={2}>{address}</td>
                        <td colSpan={2}>
                          {typeof centerName === 'string' &&
                            splitSmartText(centerName).map((chunk, index, arr) => (
                              <React.Fragment key={index}>
                                {chunk}
                                {index < arr.length - 1}
                                <br />
                              </React.Fragment>
                            ))}
                        </td>
                      </tr>
                      <tr>
                        <th>PinCode</th>
                        <th>State</th>
                        <th>City</th>
                        <th>Status</th>
                        <th>Created Date</th>
                      </tr>
                      <tr>

                        <td>{pincode}</td>
                        <td>{state}</td>
                        <td>{city}</td>
                        <td>{status ? "Active" : "De-Activated"}</td>
                        <td>{moment(createdAt).format("DD-MM-YYYY")}</td>

                      </tr>

                    </thead>
                  </table>
                </div>
              </div>
              <div className="modal-footer">

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmployeeList;
